import React, { useState } from "react";
import SelfPaymentForm from "./SelfPayment";
import axios from "axios";

export default function SelfPaymentFlow() {
  const [loading, setLoading] = useState(false);
  const [paymentInfo, setPaymentInfo] = useState(null); 
  // paymentInfo = { payment_url, gateway }

  const handleFormComplete = async (data) => {
    try {
      setLoading(true);

      // 1️⃣ Create payment session
      const res = await axios.post(
        "https://booktrip4me.com/api/create-payment-session.php",
        data,
        { headers: { "Content-Type": "application/json" } }
      );

      const { payment_url } = res.data;

      // 2️⃣ Send email (optional but recommended)
      axios.post("https://booktrip4me.com/api/self-payment-email.php", {
        ...data,
        payment_url,
      }).catch(() => {
        console.warn("Email sending failed");
      });

      // 3️⃣ Save info for UI
      setPaymentInfo({
        payment_url,
        gateway: data.gateway,
      });
    } catch (err) {
      console.error("Payment session failed", err);
      alert("Failed to create payment link");
    } finally {
      setLoading(false);
    }
  };

  /* ================= LOADING ================= */

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-gray-500">Creating secure payment link...</p>
      </div>
    );
  }

  /* ================= SUCCESS SCREEN ================= */

  if (paymentInfo) {
    const { payment_url, gateway } = paymentInfo;

    const copyLink = async () => {
      try {
        await navigator.clipboard.writeText(payment_url);
        alert("Payment link copied to clipboard ✅");
      } catch {
        alert("Failed to copy link");
      }
    };

    return (
      <div className="min-h-screen flex items-center justify-center px-4">
        <div className="w-full max-w-lg bg-white rounded-xl shadow p-6 space-y-5 text-center">

          <h2 className="text-2xl font-semibold text-emerald-600">
            Payment Link Generated
          </h2>

          <p className="text-sm text-gray-600">
            Gateway selected:{" "}
            <span className="font-semibold capitalize">
              {gateway === "nmi" ? "NMI" : "Stripe"}
            </span>
          </p>

          {/* LINK BOX */}
          <div className="bg-gray-50 border rounded-lg p-3 text-sm break-all">
            {payment_url}
          </div>

          {/* ACTIONS */}
          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={copyLink}
              className="flex-1 px-4 py-2 bg-black text-white rounded-lg"
            >
              Copy Payment Link
            </button>

            <a
              href={payment_url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 px-4 py-2 border border-gray-300 rounded-lg"
            >
              Open Link
            </a>
          </div>

          {/* GATEWAY NOTE */}
          <p className="text-xs text-gray-500">
            {gateway === "stripe"
              ? "Customer will be redirected to Stripe secure payment page."
              : "Customer will be redirected to NMI secure card payment page."}
          </p>

          {/* RESET */}
          <button
            onClick={() => setPaymentInfo(null)}
            className="text-sm text-gray-500 underline mt-2"
          >
            Create another payment link
          </button>
        </div>
      </div>
    );
  }

  /* ================= FORM ================= */

  return <SelfPaymentForm onComplete={handleFormComplete} />;
}
